<template>
  <md-toolbar
    md-elevation="0"
    class="md-transparent"
    :class="{
      'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute
    }"
  >
    <div class="md-toolbar-row">
      <div class="md-toolbar-section-start">
        <md-list-item v-if="formConfig.pageMode === 'view' || formConfig.pageMode === 'assignee'" @click="formConfig.pageMode = 'edit'">
              <i class="material-icons">edit</i>
              <p class="hidden-lg hidden-md">Edit</p>
            </md-list-item>

        <!-- Case Status dropdown above Case Detail/Edit Form -->
        <SelectDynamicModel :config="dynamicSelectConfig" :formConfig="formConfig" />

        <!-- Case Assignee dropdown above Case Detail/Edit Form -->
        <AutocompleteDynamicModel
          :config="dynamicAssigneeConfig"
          :reassignTasks="reassignTasks"
          :form="form"
          :save="save"
          :formConfig="formConfig"
          :recordData="recordData"
          :field="field"
        />

        <!-- <CrudSelect
              v-else-if="fields.type == 'select'" :key="fields.label" class="field"
        :name="fields.label" :form="form" :pageMode="pageMode" :$vo="[]" :field.sync="field"></CrudSelect>-->

            <li class="md-list-item" v-if="$Session.user">
              <a
                :href="'#' + $route.path"
                class="md-list-item-router md-list-item-container md-button-clean dropdown"
              >
                <div class="md-list-item-content">
                  <drop-down direction="down" v-if="atShowAuditLog || formConfig.showMergeCaseOption">
                    <md-button
                      slot="title"
                      class="md-button md-just-icon md-simple"
                      data-toggle="dropdown"
                    >
                      <md-icon>more_vert</md-icon>
                      <!--                  <span class="notification">{{ $Session.alerts.length }}</span>-->
                      <p class="hidden-lg hidden-md">More Options</p>
                    </md-button>
                    <ul class="dropdown-menu dropdown-menu-right">
                      <li v-if="formConfig.showMergeCaseOption">
                        <a :href="'#' + $route.path" @click="openDialog">
                      <md-icon>merge_type</md-icon>Merge Case
                        </a>
                      </li>
                      <li v-if="atShowAuditLog">
                        <a @click="atShowAuditLog">
                      <md-icon>visibility</md-icon>Audit Log
                        </a>
                      </li>
                    </ul>
                  </drop-down>
                </div>
              </a>
            </li>
      </div>
      <div class="md-toolbar-section-end">
        <div class="md-collapse">
          <md-list>
            <md-list-item
              v-if="formConfig.pageMode === 'edit'"
              v-on:click="save"
              :disabled="btnActive ? ($v.form.$invalid) : ($v.form.$invalid || !$v.form.$anyDirty)"
            >
              <i class="material-icons">save</i>
              <p class="hidden-lg hidden-md">Save</p>
            </md-list-item>

            <md-list-item v-if="formConfig.pageMode === 'edit'" v-on:click="cancel">
              <i class="material-icons">close</i>
              <p class="hidden-lg hidden-md">Cancel</p>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
import SelectDynamicModel from '@/components/Crud/Inputs/SelectDynamicModel'
import AutocompleteDynamicModel from '@/components/Crud/Inputs/AutocompleteDynamicModel'
  export default {
    name: "case-crud-toolbar",
    components: {
      SelectDynamicModel,
      AutocompleteDynamicModel
    },
    props: {
      cancel: {
        type: Function,
        required: true
      },
      save: {
        type: Function,
        required: true
      },
      formConfig: {
        type: Object,
        required: true
      },
      form: {
        type: Object,
        required: true
      },
      $v: {
        type: Object,
        required: true
      },
      btnActive: {
        type: Boolean
      },
      atShowAuditLog: {
        type: Function,
        required: true
      },
      reassignTasks: {
        type: [Object, Array],
        required: false
      },
      recordData: {
        type: Object,
      },
      field: {
        type: Object,
      }
    },
    data() {
    return {
      dynamicSelectConfig: {
        label: 'Status',
        showFilter: true,
        columnFilterList: [],
        defaultSelectedValue: this.recordData.status ? this.recordData.status.replace(/_/g, " ") : '',
        filterListQueryId: "getListCaseStatusEnum",
        updateMutationId: "updateCase",
        fieldToBeUpdate: "status",
        updatedById: "caseUpdatedById",
      },
      dynamicAssigneeConfig: {
        label: 'Assignee',
        showFilter: true,
        defaultSelectedValue: this.formConfig.fields.caseUserId.searchTerm,
        filterListQueryId: "searchUsers",
        updateMutationId: "updateCase",
        fieldToBeUpdate: "caseUserId",
        updatedById: "caseUpdatedById",
      }
    };
    },
    methods: {
      openDialog() {
        if(this.formConfig.openCaseMergeDialog && 'function' == typeof this.formConfig.openCaseMergeDialog){
          //add class on body to prevent scrolling when case dialog popup
          const body = document.querySelector('body');
          body.classList.add('isCaseDialogOpen');

          this.formConfig.openCaseMergeDialog();
        }
      }
    },
    watch: {
      'formConfig.fields.caseUserId.searchTerm': {
        immediate: true,
        handler: function() {
            console.log("currentItem Changed");
            this.dynamicAssigneeConfig.defaultSelectedValue = this.formConfig.fields.caseUserId.searchTerm
        },
      },
    },
  };
</script>
<style>
body.isCaseDialogOpen {
  overflow-y: hidden;
}
</style>